import { render, staticRenderFns } from "./advancedCopywriter.vue?vue&type=template&id=10f9ecaf&scoped=true"
import script from "./advancedCopywriter.vue?vue&type=script&lang=js"
export * from "./advancedCopywriter.vue?vue&type=script&lang=js"
import style0 from "./advancedCopywriter.vue?vue&type=style&index=0&id=10f9ecaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f9ecaf",
  null
  
)

export default component.exports